"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoungeUIElementName = exports.UIElementName = void 0;
// ClickEvent target elements for the main website
var UIElementName;
(function (UIElementName) {
    // Auth
    UIElementName["BUTTON_SIGNUP_CONTINUE"] = "BUTTON_SIGNUP_CONTINUE";
    UIElementName["BUTTON_LOGIN_CONTINUE"] = "BUTTON_LOGIN_CONTINUE";
    UIElementName["BUTTON_SIGNUP_OTP_VERIFY"] = "BUTTON_SIGNUP_OTP_VERIFY";
    UIElementName["BUTTON_LOGIN_OTP_VERIFY"] = "BUTTON_LOGIN_OTP_VERIFY";
    UIElementName["BUTTON_SIGNUP_FACEBOOK"] = "BUTTON_SIGNUP_FACEBOOK";
    UIElementName["BUTTON_LOGIN_FACEBOOK"] = "BUTTON_LOGIN_FACEBOOK";
    UIElementName["BUTTON_SIGNUP_GUEST_CONTINUE"] = "BUTTON_SIGNUP_GUEST_CONTINUE";
    UIElementName["LINK_SIGNUP_OTP_CALL_US"] = "LINK_SIGNUP_OTP_CALL_US";
    UIElementName["LINK_LOGIN_OTP_CALL_US"] = "LINK_LOGIN_OTP_CALL_US";
    UIElementName["BUTTON_SIGNUP_OTP_RESEND"] = "BUTTON_SIGNUP_OTP_RESEND";
    UIElementName["BUTTON_LOGIN_OTP_RESEND"] = "BUTTON_LOGIN_OTP_RESEND";
    UIElementName["BUTTON_SIGNUP_OTP_CHANGE_PHONE_NUMBER"] = "BUTTON_SIGNUP_OTP_CHANGE_PHONE_NUMBER";
    UIElementName["BUTTON_LOGIN_OTP_CHANGE_PHONE_NUMBER"] = "BUTTON_LOGIN_OTP_CHANGE_PHONE_NUMBER";
    UIElementName["BUTTON_SIGNUP_OTP_SUCCESS_NEXT"] = "BUTTON_SIGNUP_OTP_SUCCESS_NEXT";
    // Header
    UIElementName["LINK_HEADER_LOGO"] = "LINK_HEADER_LOGO";
    UIElementName["LINK_HEADER_CALL_US"] = "LINK_HEADER_CALL_US";
    // Sidebar
    UIElementName["BUTTON_SIDEBAR_MENU"] = "BUTTON_SIDEBAR_MENU";
    UIElementName["BUTTON_SIDEBAR_MENU_SIGNUP"] = "BUTTON_SIDEBAR_MENU_SIGNUP";
    UIElementName["LINK_SIDEBAR_HOME"] = "LINK_SIDEBAR_HOME";
    UIElementName["LINK_SIDEBAR_MENU_ABOUT_US"] = "LINK_SIDEBAR_MENU_ABOUT_US";
    UIElementName["LINK_SIDEBAR_MENU_CAREERS"] = "LINK_SIDEBAR_MENU_CAREERS";
    UIElementName["LINK_SIDEBAR_MENU_CONTACT_US"] = "LINK_SIDEBAR_MENU_CONTACT_US";
    UIElementName["LINK_SIDEBAR_MENU_FAQ"] = "LINK_SIDEBAR_MENU_FAQ";
    UIElementName["LINK_SIDEBAR_MENU_HOST_SESSION"] = "LINK_SIDEBAR_MENU_HOST_SESSION";
    UIElementName["LINK_SIDEBAR_MENU_PRESS"] = "LINK_SIDEBAR_MENU_PRESS";
    UIElementName["LINK_SIDEBAR_MENU_PRICING"] = "LINK_SIDEBAR_MENU_PRICING";
    UIElementName["LINK_SIDEBAR_MENU_SHOP"] = "LINK_SIDEBAR_MENU_SHOP";
    UIElementName["LINK_SIDEBAR_MENU_VIEW_PROFILE"] = "LINK_SIDEBAR_MENU_VIEW_PROFILE";
    UIElementName["LINK_SIDEBAR_SCHEDULE"] = "LINK_SIDEBAR_SCHEDULE";
    UIElementName["LINK_SIDEBAR_STORIES"] = "LINK_SIDEBAR_STORIES";
    // Footer
    UIElementName["LINK_FOOTER_ABOUT_US"] = "LINK_FOOTER_ABOUT_US";
    UIElementName["LINK_FOOTER_CONTACT_US"] = "LINK_FOOTER_CONTACT_US";
    UIElementName["LINK_FOOTER_FAQ"] = "LINK_FOOTER_FAQ";
    UIElementName["LINK_FOOTER_PRIVACY_POLICY"] = "LINK_FOOTER_PRIVACY_POLICY";
    UIElementName["LINK_FOOTER_TERMS_CONDITIONS"] = "LINK_FOOTER_TERMS_CONDITIONS";
    // OVERLAYS
    UIElementName["BUTTON_OVERLAY_BACK_TO_TOP"] = "BUTTON_OVERLAY_BACK_TO_TOP";
    UIElementName["BUTTON_OVERLAY_HELP"] = "BUTTON_OVERLAY_HELP";
    //Series
    UIElementName["BUTTON_SERIES_VIEW_UPCOMING"] = "BUTTON_SERIES_VIEW_UPCOMING";
    //Schedule
    UIElementName["BUTTON_SCHEDULE_FILTERS"] = "BUTTON_SCHEDULE_FILTERS";
    UIElementName["BUTTON_SCHEDULE_BROWSE_PAGE"] = "BUTTON_SCHEDULE_BROWSE_PAGE";
    UIElementName["BUTTON_SCHEDULE_MY_SCHEDULE_PAGE"] = "BUTTON_SCHEDULE_MY_SCHEDULE_PAGE";
    UIElementName["BUTTON_SCHEDULE_TIME_SLIDER"] = "BUTTON_SCHEDULE_TIME_SLIDER";
    //Bottom bar
    UIElementName["BUTTON_BOTTOM_BAR_HOME"] = "BUTTON_BOTTOM_BAR_HOME";
    UIElementName["BUTTON_BOTTOM_BAR_SCHEDULE"] = "BUTTON_BOTTOM_BAR_SCHEDULE";
    UIElementName["BUTTON_BOTTOM_BAR_SERIES"] = "BUTTON_BOTTOM_BAR_SERIES";
    UIElementName["BUTTON_BOTTOM_BAR_PROFILE"] = "BUTTON_BOTTOM_BAR_PROFILE";
    //Classes
    UIElementName["BUTTON_CLASS_CARD_VIEW"] = "BUTTON_CLASS_CARD_VIEW";
    UIElementName["BUTTON_CLASS_CARD_BOOK"] = "BUTTON_CLASS_CARD_BOOK";
    UIElementName["BUTTON_CLASS_CARD_ENTER"] = "BUTTON_CLASS_CARD_ENTER";
    UIElementName["BUTTON_CLASS_CARD_AUTH"] = "BUTTON_CLASS_CARD_AUTH";
    UIElementName["BUTTON_CLASS_DETAIL_BOOK"] = "BUTTON_CLASS_DETAIL_BOOK";
    UIElementName["BUTTON_CLASS_DETAIL_ENTER"] = "BUTTON_CLASS_DETAIL_ENTER";
    UIElementName["BUTTON_CLASS_DETAIL_AUTH"] = "BUTTON_CLASS_DETAIL_AUTH";
    UIElementName["BUTTON_CATEGORY_PILL"] = "BUTTON_CATEGORY_PILL";
    UIElementName["LINK_VIEW_MORE"] = "LINK_VIEW_MORE";
    UIElementName["LINK_HERO_BANNER"] = "LINK_HERO_BANNER";
    // AD Banners
    UIElementName["LINK_PARTNER_AD_BANNER"] = "LINK_PARTNER_AD_BANNER";
    UIElementName["BUTTON_PARTNER_AD_BANNER"] = "BUTTON_PARTNER_AD_BANNER";
})(UIElementName = exports.UIElementName || (exports.UIElementName = {}));
// ClickEvent target elements for the Lounge
var LoungeUIElementName;
(function (LoungeUIElementName) {
    LoungeUIElementName["LOUNGE_BUTTON_TOO_EARLY_WATCH_PREVIOUS"] = "LOUNGE_BUTTON_TOO_EARLY_WATCH_PREVIOUS";
    LoungeUIElementName["LOUNGE_BUTTON_IN_PROGRESS_WATCH_FROM_START"] = "LOUNGE_BUTTON_IN_PROGRESS_WATCH_FROM_START";
    LoungeUIElementName["LOUNGE_BUTTON_IN_PROGRESS_WATCH_LIVE"] = "LOUNGE_BUTTON_IN_PROGRESS_WATCH_LIVE";
    LoungeUIElementName["LOUNGE_BUTTON_TOO_LATE_RESTART"] = "LOUNGE_BUTTON_TOO_LATE_RESTART";
    LoungeUIElementName["LOUNGE_BUTTON_TAB_CHAT"] = "LOUNGE_BUTTON_TAB_CHAT";
    LoungeUIElementName["LOUNGE_BUTTON_TAB_INFO"] = "LOUNGE_BUTTON_TAB_INFO";
    LoungeUIElementName["LOUNGE_BUTTON_TAB_EXPLORE"] = "LOUNGE_BUTTON_TAB_EXPLORE";
    LoungeUIElementName["LOUNGE_BUTTON_INFO_HELP"] = "LOUNGE_BUTTON_INFO_HELP";
    LoungeUIElementName["LOUNGE_BUTTON_BACK"] = "LOUNGE_BUTTON_BACK";
    LoungeUIElementName["LOUNGE_BUTTON_EXPLORE_OUR_GUIDE"] = "LOUNGE_BUTTON_EXPLORE_OUR_GUIDE";
    LoungeUIElementName["LOUNGE_BUTTON_CLASS_NOTES"] = "LOUNGE_BUTTON_CLASS_NOTES";
    LoungeUIElementName["LOUNGE_LINK_LOGO"] = "LOUNGE_LINK_LOGO";
})(LoungeUIElementName = exports.LoungeUIElementName || (exports.LoungeUIElementName = {}));
//# sourceMappingURL=ui-element-names.js.map